import React, { useMemo } from 'react';
import { bool, arrayOf, func, shape } from 'prop-types';
import { Filmstrip } from '@one-thd/sui-carousel';
import { Typography } from '@one-thd/sui-atomic-components';
import { extend } from '@thd-nucleus/data-sources';
import { MultiParentItem } from './MultiParentItem';
import { MULTI_ENTRY_POINT_BREAKPOINTS } from '../../constants/ui';
import { BundleMiniPlaceholder } from '../BundleMiniPlaceholder';

const MultiParentCarousel = ({ bundles, bundleLoading, onError }) => {

  const CarouselSlides = useMemo(() => {
    if (bundleLoading) {
      return [...Array(5)].map((__, index) => (
        <BundleMiniPlaceholder key={index} isMultiParent />
      ));
    }
    return bundles?.map((bundle) => (
      <MultiParentItem
        bundle={bundle}
        key={bundle?.bundleId}
      />
    )) || [];
  }, [bundles, bundleLoading]);

  if (!bundles?.length && !bundleLoading) {
    onError();
    return null;
  }

  return (
    <div
      data-testid="multi-parent-carousel"
      className="sui-bg-primary sui-mb-2 lg:sui-mt-2 lg:sui-mb-4 sui-w-full sui-pt-4 sui-pl-4"
    >
      <Typography variant="h2">Available Bundles</Typography>
      <Filmstrip
        breakpoints={MULTI_ENTRY_POINT_BREAKPOINTS}
        slidesPerView={1}
        spaceBetween={16}
        slidesPerGroup={1}
        peek="sm"
      >
        {CarouselSlides}
      </Filmstrip>
    </div>
  );
};

MultiParentCarousel.propTypes = {
  bundles: arrayOf(shape({})),
  bundleLoading: bool,
  onError: func
};

MultiParentCarousel.defaultProps = {
  bundles: [],
  bundleLoading: false,
  onError: () => {}
};

MultiParentCarousel.displayName = 'MultiParentCarousel';

MultiParentCarousel.dataModel = extend(
  MultiParentItem
);

export { MultiParentCarousel };